module.exports = __webpack_public_path__ + "log-in/img/paw-avatar.0909ba3c.png";